import regenerateInvoiceService from './axiosInstances/regenerateInvoiceService';

export const regenerateInvoiceByTxnId = (txnId, triggerEmails) => {
  return regenerateInvoiceService.post(
    `/invoice/regenerate-receipts/${txnId}?sendInvoice=${triggerEmails}`
  );
};
